import { render, staticRenderFns } from "./VDropdownButton.vue?vue&type=template&id=3f18a71e"
import script from "./VDropdownButton.vue?vue&type=script&lang=ts"
export * from "./VDropdownButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports